import React from 'react';

const Input = ({ id, label, type = 'text', value, onChange, required, error, ...props }) => {
  const labelStyle = "block mb-2 text-sm font-medium text-gray-700 dark:text-gray-200";
  
  const inputStyle = `
    w-full px-3 py-2 border rounded-md shadow-sm
    placeholder-gray-400 dark:placeholder-gray-500 
    bg-white dark:bg-gray-700
    text-gray-900 dark:text-white
    focus:outline-none focus:ring-1 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400
    transition-colors duration-300
    ${error 
        ? 'border-red-500 dark:border-red-400' 
        : 'border-gray-300 dark:border-gray-600'}
  `;

  return (
    <div>
      <label htmlFor={id} className={labelStyle}>
        {label} {required && <span className="text-red-500 dark:text-red-400">*</span>}
      </label>
      <input
        id={id}
        name={id}
        type={type}
        value={value}
        onChange={onChange}
        className={inputStyle}
        {...props}
      />
      {error && <p className="text-red-500 dark:text-red-400 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default Input;